import { render, staticRenderFns } from "./ContactosWhatsApp.vue?vue&type=template&id=81023de0&scoped=true&"
import script from "./ContactosWhatsApp.vue?vue&type=script&lang=js&"
export * from "./ContactosWhatsApp.vue?vue&type=script&lang=js&"
import style0 from "./ContactosWhatsApp.vue?vue&type=style&index=0&id=81023de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81023de0",
  null
  
)

export default component.exports